import React, { Component } from 'react';

class RouteElementContentTitle extends Component {
	render() {
		return <div className = 'route_element_content_title'>
			{this.props.display}
		</div>;
	}
}

export default RouteElementContentTitle;


// WEBPACK FOOTER //
// ./src/components/home/RouteElementContentTitle.jsx